var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 29,
    viewBox: "0 0 37 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.7778 15.6914L35.2778 15.6914L35.2778 12.6914L33.7778 12.6914L33.7778 15.6914ZM3.71711 13.1307C3.13132 13.7165 3.13132 14.6663 3.71711 15.2521L13.2631 24.798C13.8488 25.3838 14.7986 25.3838 15.3844 24.798C15.9702 24.2122 15.9702 23.2625 15.3844 22.6767L6.89909 14.1914L15.3844 5.70613C15.9702 5.12034 15.9702 4.17059 15.3844 3.58481C14.7986 2.99902 13.8488 2.99902 13.2631 3.58481L3.71711 13.1307ZM33.7778 12.6914L4.77777 12.6914L4.77777 15.6914L33.7778 15.6914L33.7778 12.6914Z",
    fill: "white",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoBack);
export default __webpack_public_path__ + "static/media/go-back.6d68e87d7fb4cb8beb677bccd55d6e93.svg";
export { ForwardRef as ReactComponent };